import React, { Component } from 'react';


export default class SelectCountry extends Component   {
    constructor(props) {
        super(props);
        this.state = {
            countries: [],
        };
    }

    componentDidMount() {
        // Chiama il servizio rest e assegna i dati allo stato
        this.loadCountries();
    }

    // versione con controller/service locale
    // async loadCountries(){
    //     try {
    //         const response = await fetch('/api/list_countries');
    //         if (!response.ok) {
    //             throw Error(response.statusText);
    //         }
    //         const json = await response.json();
    //         this.setState({ countries: json });
    //     } catch (error) {
    //         console.log(error);
    //     }
    // }

    // versione con service basato su libreria pragmarx/countries
    async loadCountries(){
        try {
            const response = await fetch('/api/list_countries_library');
            if (!response.ok) {
                throw Error(response.statusText);
            }
            const json = await response.json();
            this.setState({ countries: json });

        } catch (error) {
            console.log(error);
        }
    }

    render() {
        // Controlla la validità
        var classValidation = '';
        // cambia la classe di validazione

        // console.log("controlla valore per " + this.props.name + " messaggio invalido " + this.props.invalid_message);

        if(this.props.invalid_message != undefined && this.props.invalid_message !== ''){
            classValidation = 'is-invalid';
        }

        var requiredClass = '';
        if(this.props.required){
            requiredClass = 'nam_required';
        }

        let arrayOfData = this.state.countries;

        // let options = arrayOfData.map((data) =>
        //         <option key={data.id}  value={data.id}>
        //             {data.name}
        //         </option>
        //     );
        if(arrayOfData.length != 0){
            return (
                <div className="form-group row">
                    <div className="col-sm-12">
                        <label htmlFor={this.props.name} className="col-form-label font-weight-bold">{this.props.label}</label>
                        <select
                            name={this.props.name}
                            value={this.props.value}
                            onChange={this.props.handleChange}
                            className="custom-select">
                                {/* <option value=''>{this.props.not_selected}</option>
                                {options} */}
                                <option value="">-- Seleziona un paese --</option>
                                {Object.entries(arrayOfData).map(([code, name]) => (
                                    <option key={code} value={code}>
                                    {name}
                                    </option>
                                ))}
                        </select>
                        <div className="invalid-feedback">
                            {this.props.invalid_message}
                        </div>
                    </div>
                </div>
            );
        } else {
            return (
                <div className="form-group row">
                    <div className="col-sm-12">
                        <label htmlFor={this.props.name} className="col-form-label font-weight-bold">{this.props.label}</label>
                        <input type="text"
                            name={this.props.name}
                            value={this.props.value}
                            onChange={this.props.handleChange}
                            className={'form-control ' + classValidation + ' ' + requiredClass}
                            disabled={true}
                            placeholder='Nessun paese trovato, provare a ricaricare la pagina!'
                            />
                        <div className="invalid-feedback">
                            {this.props.invalid_message}
                        </div>
                    </div>
                </div>
            );
        }
    }
}
